/* jshint esversion: 6, -W097 */
/* globals require */
(function(angular) {
    'use strict';
    var app = angular.module('enervee');

    app.directive('searchBox', [function() {
        return {
            restrict: 'E',
            scope: {
                page: "@"
            },
            controller: [
                '$scope',
                'SearchService',
                'CmsContentService',
                'UtilService',
                'CategoriesService',
                function ($scope,
                          SearchService,
                          CmsContentService
                ) {

                    // get cms search box text
                    CmsContentService.getMarketPlaceText('base:header:search_box_text').then(function(text) {
                        $scope.searchBoxText = text;
                    });

                    // get cms search box text
                    CmsContentService.getMarketPlaceText('base:header:search_box_text_short').then(function(text) {
                        $scope.searchBoxTextShort = text;
                    });

                    $scope.openAutocomplete = SearchService.openAutocomplete;
                }],
            template: require('@app/shared/search/searchBoxView.html'),
        };

    }]);

})(angular);